import * as React from 'react'
import { useField } from 'formik'
import { useGetCurrencyStringWithNegativePricingEnabled } from '@user/store/tenantFeatures/hooks/useGetCurrencyStringWithNegativePricingEnabled'
import { TextField, TextFieldProps } from '@workwave-tidal/core/components'
interface Props
  extends Omit<
    TextFieldProps,
    'name' | 'value' | 'error' | 'type' | 'onBlur' | 'onChange'
  > {
  name: string
  onUpdate?: (n: string, v: string) => void
}

export const CurrencyFieldWithNegativePrice: React.FC<Props> = ({
  name,
  onUpdate,
  placeholder = '0.00',
  helperText: propsHelperText,
  ...otherProps
}) => {
  const [field, meta, helpers] = useField<string>(name)
  const { onBlur: fieldOnBlur, ...fieldProps } = field
  const { error, touched } = meta
  const { setValue } = helpers
  const hasError = touched && error !== undefined
  const helperText = hasError && !!error ? error : propsHelperText
  const formatCurrencyWithNegativePricing =
    useGetCurrencyStringWithNegativePricingEnabled()
  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    fieldOnBlur(event)

    setValue(
      field.value?.trim() ? formatCurrencyWithNegativePricing(field.value) : '',
    )

    if (onUpdate) {
      onUpdate(name, field.value)
    }
  }

  const value = field.value == '0.00' ? '' : field.value

  return (
    <TextField
      {...otherProps}
      {...fieldProps}
      onBlur={onBlur}
      error={hasError}
      helperText={helperText}
      placeholder={placeholder}
      value={value}
    />
  )
}
CurrencyFieldWithNegativePrice.displayName = 'CurrencyFieldWithNegativePrice'
